import { withDimensions } from '../../../hoc/with-dimensions';
import { GridLayout as Layout } from './grid-layout';
export const GridLayout = withDimensions(Layout);
//# sourceMappingURL=index.js.map